// Display formatting for block renderers. Blocks arrive display-ready where they
// can (metric tiles carry preformatted strings); these helpers cover the numeric
// cases (chart series, money table cells).
//
// CONTRACT: numeric money values are in MAJOR units (dollars). The emitter owns
// the minor->major conversion, so renderers never divide by 100 — this keeps the
// cents/dollars trap out of the UI. Multi-currency is a follow-up; USD for now.

// Cents are never rounded away in a value the user reads as an amount. The
// reconciled predicate is `ABS(difference) <= 1 cent`, so a cell showing
// $1,235 for $1,234.56 misstates whether something reconciles. Axis TICKS are
// the one exception — those are a scale, not an amount.
const usdExact = new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD",
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
});

const usdWhole = new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD",
	maximumFractionDigits: 0,
});

const number = new Intl.NumberFormat("en-US");

export function formatMoney(value: unknown): string {
	if (typeof value === "number") return usdExact.format(value);
	return value == null ? "" : String(value);
}

export function formatByUnit(
	value: number,
	unit?: "money" | "count" | "percent",
	// Axis ticks pass `false` to stay legible; tooltips and any read-as-amount
	// caller keep the default and get exact cents.
	exact = true,
): string {
	if (unit === "money") {
		return exact ? usdExact.format(value) : usdWhole.format(value);
	}
	if (unit === "percent") return `${value}%`;
	return number.format(value);
}
